export default __webpack_public_path__ + "static/media/swintLogo.1cce5a66.svg";